import { MutationTree } from 'vuex'
import { INotificationState } from './notification-state.store';
import {
  NOTIFICATION_SET_UNREAD_NOTIFICATIONS,
  NOTIFICATION_SET_NOTIFICATIONS,
  NOTIFICATION_CURRENT_CHANNEL,
  NOTIFICATION_INCREASE_UNREAD_MESSAGE,
  NOTIFICATION_SET_NOTIFICATIONS_LOADING,
  NOTIFICATION_SET_NOTIFICATIONS_FAILED,
  NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER,
  NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED,
  NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING,
  NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER,
  NOTIFICATION_DECREASE_UNREAD_MESSAGE
} from './notification-types.store';
import * as _ from "lodash";
import { ActivityStatus } from '../../common/enums';

export const mutations: MutationTree<INotificationState> = {

  [NOTIFICATION_INCREASE_UNREAD_MESSAGE]: (state: INotificationState, payload) => {
    if (state.currentChannel !== payload.fk_action_channel) {
      state.unreadNotifications.unreadCount += 1;
      state.unreadNotifications.hasNewItems += 1;
    }
  },
  [NOTIFICATION_DECREASE_UNREAD_MESSAGE]: (state: INotificationState, payload) => {
    if (state.currentChannel !== payload.fk_action_channel) {
      console.log('NOTIFICATION_DECREASE_UNREAD_MESSAGE STATE ', state)
      console.log('NOTIFICATION_DECREASE_UNREAD_MESSAGE payload ', payload)
      let notificationId = state.unreadNotifications.notifications.findIndex(notification => notification.action.id === payload.id)
      if (notificationId > -1) {
        state.unreadNotifications.unreadCount -= 1;
        //state.unreadNotifications.hasNewItems -= 1;
        state.unreadNotifications.notifications.splice(notificationId, 1)
      }
    }
  }
  , [NOTIFICATION_SET_NOTIFICATIONS_LOADING]: (state: INotificationState) => {
    state.notifications.activityStatus = ActivityStatus.Loading
    state.unreadNotifications.hasNewItems = 0;
  }
  , [NOTIFICATION_SET_NOTIFICATIONS_FAILED]: (state: INotificationState, error) => {
    state.notifications.activityStatus = ActivityStatus.LoadFailed
    state.unreadNotifications.hasNewItems = 0;
  }
  , [NOTIFICATION_SET_NOTIFICATIONS]: (state: INotificationState, { data, total, skip, limit, notificationIds, merge }) => {

    state.notifications.activityStatus = ActivityStatus.Loaded;
    if (data.length === 0 || total < limit) {
      state.notifications.scrollable = false
    } else if (total > skip) {
      state.notifications.scrollable = true
    }

    if (merge) {
      const notifications = _.filter(
        data,
        notification => !_.includes(notificationIds, notification.id)
      )
      state.notifications.notifications = state.notifications.notifications.concat(notifications)
    } else {
      state.notifications.notifications = data
    }
  }
  , [NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING]: (state: INotificationState) => {
    state.unreadNotifications.hasNewItems = 0;
    state.unreadNotifications.activityStatus = ActivityStatus.Loading
  }
  , [NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED]: (state: INotificationState, error) => {
    state.unreadNotifications.activityStatus = ActivityStatus.LoadFailed
    state.unreadNotifications.hasNewItems = 0;
  }
  , [NOTIFICATION_SET_UNREAD_NOTIFICATIONS]: (state: INotificationState, { data, total, limit, skip, notificationIds, merge }) => {

    state.unreadNotifications.activityStatus = ActivityStatus.Loaded;
    state.unreadNotifications.unreadCount = total

    if (data.length === 0 || total < limit) {
      state.unreadNotifications.scrollable = false
    } else if (total > skip) {
      state.unreadNotifications.scrollable = true
    }

    if (merge) {
      const notifications = _.filter(
        data,
        notification => !_.includes(notificationIds, notification.id)
      )
      state.unreadNotifications.notifications = state.unreadNotifications.notifications.concat(notifications)
    } else {
      state.unreadNotifications.notifications = data
    }
  }
  , [NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER]: (state: INotificationState, skip?: number) => {
    if (skip !== undefined) {
      state.notifications.searchParameter.$skip = skip
      state.notifications.scrollable = true
    } else {
      state.notifications.searchParameter.$skip += state.notifications.searchParameter.$limit
    }
  }

  , [NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER]: (state: INotificationState, skip?: number) => {
    if (skip !== undefined) {
      state.unreadNotifications.searchParameter.$skip = skip
      state.unreadNotifications.scrollable = true
    } else {
      state.unreadNotifications.searchParameter.$skip += state.unreadNotifications.searchParameter.$limit
    }
  }
  , [NOTIFICATION_CURRENT_CHANNEL]: (state: INotificationState, channeld: string) => {
    state.currentChannel = parseInt(channeld);
  }
}



// WEBPACK FOOTER //
// ./src/store/notification/notification-mutations.store.ts